var map;
var BlsCreateMapStoreLocation = (function () {
const accessToken = 'pk.eyJ1Ijoia2hpZW1waGFtIiwiYSI6ImNsam01eHhnaTAyNmczZmxzcnQ1MTVqN3gifQ.WVqIQlSk52FSN8W7G5gsnw';
const DEFAULT_GEOCODE_CACHE_MS = 30 * 24 * 60 * 60 * 1000;
let stores = [];
let selectedOrigin = null;
let selectedOriginLabel = '';
let selectedOriginSource = '';
let originMarker = null;
let originSelectionVersion = 0;
let distanceRequestVersion = 0;
let geocodeController = null;
let matrixController = null;
let mapLoadPromise = null;
let mapReady = false;
let mapElement = null;
let storeLogoUrl = '';
let defaultOriginName = '';
function escapeHtml(value) {
return String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
}
function formatDistance(meters) {
if (!Number.isFinite(meters)) return '';
const km = meters / 1000;
const value = km < 10 ? km.toFixed(1) : Math.round(km).toString();
return value.replace('.', ',') + ' km';
}
function formatDuration(seconds) {
if (!Number.isFinite(seconds)) return '';
const minutes = Math.max(1, Math.round(seconds / 60));
if (minutes < 60) return 'ca. ' + minutes + ' min';
const hours = Math.floor(minutes / 60);
const rest = minutes % 60;
return rest ? 'ca. ' + hours + ' u ' + rest + ' min' : 'ca. ' + hours + ' u';
}
function normalizedTodayHours(store) {
const hours = String(store.todayHours || '').trim();
return !hours || hours.toLowerCase() === 'gesloten' ? 'Gesloten' : hours;
}
function safeStorageGet(key) { try { return window.localStorage.getItem(key); } catch (error) { return null; } }
function safeStorageSet(key, value) { try { window.localStorage.setItem(key, value); } catch (error) {} }
function resetSearchButton() {
const button = document.getElementById('store-location-search');
if (!button) return;
button.disabled = false;
button.textContent = button.dataset.originalLabel || 'Zoeken';
}
function loadStylesheet(url) {
if (!url) return Promise.resolve();
const existing = Array.from(document.styleSheets).some(sheet => sheet.href === url);
if (existing) return Promise.resolve();
return new Promise((resolve, reject) => {
const link = document.createElement('link');
link.rel = 'stylesheet'; link.href = url; link.onload = resolve; link.onerror = reject;
document.head.appendChild(link);
});
}
function loadScript(url) {
if (window.mapboxgl) return Promise.resolve();
if (!url) return Promise.reject(new Error('Mapbox script URL missing'));
return new Promise((resolve, reject) => {
const existing = document.querySelector('script[data-bos-mapbox-loader]');
if (existing) {
existing.addEventListener('load', resolve, { once: true });
existing.addEventListener('error', reject, { once: true });
return;
}
const script = document.createElement('script');
script.src = url; script.async = true; script.dataset.bosMapboxLoader = 'true'; script.onload = resolve; script.onerror = reject;
document.head.appendChild(script);
});
}
return {
init: function () {
mapElement = document.getElementById('map');
const resultsElement = document.getElementById('store-distance-results');
if (!mapElement || !resultsElement) return;
if (mapElement.dataset.bosStoreLocationInitialized === 'true') return;
mapElement.dataset.bosStoreLocationInitialized = 'true';
storeLogoUrl = mapElement.dataset.storeLogo || '';
defaultOriginName = (mapElement.dataset.defaultOrigin || '').trim();
stores = Array.from(document.querySelectorAll('.store-infor__items')).map((element, index) => {
const rawLng = (element.dataset.lng || '').trim();
const rawLat = (element.dataset.lat || '').trim();
if (!rawLng || !rawLat) return null;
const lng = Number(rawLng); const lat = Number(rawLat);
if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;
return { id: 'store_' + index, handle: element.dataset.storeHandle || '', coordinates: [lng, lat], name: element.dataset.name || '', address: element.dataset.address || '', phone: element.dataset.phone || '', phoneUrl: element.dataset.phoneUrl || '', todayHours: element.dataset.todayHours || '', openTime: element.dataset.openTime || '', closeTime: element.dataset.closeTime || '', hoursStatus: element.dataset.hoursStatus || 'unknown', hoursUrl: element.dataset.hoursUrl || '/pages/contact', distance: null, duration: null, marker: null };
}).filter(Boolean);
if (!stores.length) return;
this.initControls(); this.renderResults(); this.initLazyMap();
if (defaultOriginName) {
const input = document.getElementById('store-location-input');
if (input && !input.value) input.value = defaultOriginName;
this.resolveLocation(defaultOriginName, 'page');
}
},
initControls: function () {
const input = document.getElementById('store-location-input');
const searchButton = document.getElementById('store-location-search');
const locationButton = document.getElementById('store-use-location');
if (input) input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); this.searchTypedLocation(); } });
if (searchButton) searchButton.addEventListener('click', () => this.searchTypedLocation());
if (locationButton) locationButton.addEventListener('click', () => this.useCurrentLocation());
},
searchTypedLocation: function () {
const input = document.getElementById('store-location-input');
const query = input ? input.value.trim() : '';
if (!query) { this.setStatus('Vul eerst een postcode, plaats of adres in.'); if (input) input.focus(); return; }
this.resolveLocation(query, 'manual');
},
resolveLocation: async function (query, source) {
const requestId = ++originSelectionVersion;
const searchButton = document.getElementById('store-location-search');
const isManual = source === 'manual';
if (geocodeController) geocodeController.abort();
geocodeController = new AbortController();
if (isManual && searchButton) { searchButton.disabled = true; searchButton.dataset.originalLabel = searchButton.dataset.originalLabel || searchButton.textContent; searchButton.textContent = 'Zoeken…'; }
if (source === 'page' && !selectedOrigin) { selectedOriginLabel = query; selectedOriginSource = 'page'; this.renderResults(); }
this.setStatus(source === 'page' ? 'Afstanden vanaf ' + query + ' worden berekend…' : 'Locatie wordt gezocht…');
const cacheKey = 'bos-store-origin:v1:' + query.toLowerCase();
if (source === 'page') {
const cachedRaw = safeStorageGet(cacheKey);
if (cachedRaw) try {
const cached = JSON.parse(cachedRaw);
if (cached && Array.isArray(cached.coordinates) && cached.coordinates.length === 2 && Date.now() - cached.savedAt < DEFAULT_GEOCODE_CACHE_MS) { this.setOrigin(cached.coordinates, query, source); return; }
} catch (error) {}
}
const params = new URLSearchParams({ q: source === 'page' ? query + ', Nederland' : query, access_token: accessToken, country: 'NL', language: 'nl', limit: '1', types: source === 'page' ? 'place,locality' : 'address,street,postcode,place,locality,neighborhood' });
try {
const response = await fetch('https://api.mapbox.com/search/geocode/v6/forward?' + params.toString(), { signal: geocodeController.signal });
if (!response.ok) throw new Error('Geocoding request failed');
const data = await response.json();
if (requestId !== originSelectionVersion) return;
const feature = data.features && data.features[0];
const coordinates = feature && feature.geometry && feature.geometry.coordinates;
if (!coordinates || coordinates.length < 2) { this.setStatus('Deze locatie kon niet worden gevonden. Controleer de plaats, postcode of het adres.'); return; }
const cleanCoordinates = [Number(coordinates[0]), Number(coordinates[1])];
if (!Number.isFinite(cleanCoordinates[0]) || !Number.isFinite(cleanCoordinates[1])) throw new Error('Invalid geocode coordinates');
const properties = feature.properties || {};
const label = source === 'page' ? query : (properties.full_address || properties.place_formatted || properties.name_preferred || properties.name || query);
if (source === 'page') safeStorageSet(cacheKey, JSON.stringify({ coordinates: cleanCoordinates, savedAt: Date.now() }));
this.setOrigin(cleanCoordinates, label, source);
} catch (error) {
if (error.name === 'AbortError' || requestId !== originSelectionVersion) return;
if (source === 'page' && !selectedOrigin) { selectedOriginLabel = ''; selectedOriginSource = ''; this.renderResults(); }
this.setStatus(source === 'page' ? 'De afstanden vanaf ' + query + ' konden nu niet automatisch worden berekend. Je kunt zelf een locatie invullen.' : 'De locatie kon nu niet worden opgezocht. Probeer het opnieuw of gebruik je huidige locatie.');
} finally { if (isManual && requestId === originSelectionVersion) resetSearchButton(); }
},
useCurrentLocation: function () {
const button = document.getElementById('store-use-location');
if (!navigator.geolocation) { this.setStatus('Je browser ondersteunt locatiebepaling niet. Vul je postcode, plaats of adres in.'); return; }
const requestId = ++originSelectionVersion;
if (geocodeController) geocodeController.abort();
if (matrixController) matrixController.abort();
resetSearchButton(); if (button) button.disabled = true; this.setStatus('Je locatie wordt opgehaald…');
navigator.geolocation.getCurrentPosition(position => {
if (button) button.disabled = false;
if (requestId !== originSelectionVersion) return;
const input = document.getElementById('store-location-input'); if (input) input.value = '';
this.setOrigin([position.coords.longitude, position.coords.latitude], 'jouw huidige locatie', 'geolocation');
}, () => {
if (button) button.disabled = false;
if (requestId !== originSelectionVersion) return;
this.setStatus('Je locatie kon niet worden opgehaald. Vul je postcode, plaats of adres in.');
}, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
},
setOrigin: function (coordinates, label, source) {
if (!Number.isFinite(coordinates[0]) || !Number.isFinite(coordinates[1])) return;
selectedOrigin = coordinates; selectedOriginLabel = label || 'je startlocatie'; selectedOriginSource = source || 'manual';
stores.forEach(store => { store.distance = null; store.duration = null; });
this.updateOriginControls(); this.renderResults(); this.updateOriginMarker(); this.fitOriginAndStores(); this.calculateDistances();
},
updateOriginControls: function () {
const button = document.getElementById('store-use-location'); if (!button) return;
const active = selectedOriginSource === 'geolocation'; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', active ? 'true' : 'false');
},
calculateDistances: async function () {
if (!selectedOrigin || !stores.length) return;
const requestId = ++distanceRequestVersion; const originLabel = selectedOriginLabel;
if (matrixController) matrixController.abort(); matrixController = new AbortController();
this.setStatus('Afstanden en reistijden vanaf ' + originLabel + ' worden berekend…');
const coordinates = [selectedOrigin].concat(stores.map(store => store.coordinates)).map(item => item[0] + ',' + item[1]).join(';');
const destinations = stores.map((store, index) => index + 1).join(';');
const url = 'https://api.mapbox.com/directions-matrix/v1/mapbox/driving-traffic/' + coordinates + '?sources=0&destinations=' + destinations + '&annotations=distance,duration&access_token=' + accessToken;
try {
const response = await fetch(url, { signal: matrixController.signal }); if (!response.ok) throw new Error('Matrix request failed');
const data = await response.json(); if (requestId !== distanceRequestVersion) return;
const distances = data.distances && data.distances[0]; const durations = data.durations && data.durations[0];
if (!distances || !durations || distances.length !== stores.length || durations.length !== stores.length) throw new Error('No matrix results');
stores.forEach((store, index) => { store.distance = Number.isFinite(distances[index]) ? distances[index] : null; store.duration = Number.isFinite(durations[index]) ? durations[index] : null; });
this.renderResults(); this.setStatus('Afstand vanaf ' + originLabel + '. De dichtstbijzijnde showroom staat bovenaan.');
} catch (error) {
if (error.name === 'AbortError' || requestId !== distanceRequestVersion) return;
stores.forEach(store => { store.distance = null; store.duration = null; }); this.renderResults(); this.setStatus('De rijafstand kon nu niet worden berekend. Je kunt wel direct een route naar een showroom openen.');
}
},
initLazyMap: function () {
if (!mapElement) return; const load = () => this.loadMap();
if ('IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); } }, { rootMargin: '250px 0px' }); observer.observe(mapElement); }
else if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 2500 }); else setTimeout(load, 1200);
},
loadMap: function () {
if (mapLoadPromise) return mapLoadPromise; if (!mapElement) return Promise.resolve();
const jsUrl = mapElement.dataset.mapboxJs || ''; const cssUrl = mapElement.dataset.mapboxCss || ''; mapElement.classList.add('is-loading');
mapLoadPromise = Promise.all([loadStylesheet(cssUrl), loadScript(jsUrl)]).then(() => { if (!window.mapboxgl) throw new Error('Mapbox unavailable'); return this.initMap(); }).catch(() => { mapElement.classList.remove('is-loading'); mapElement.classList.add('is-unavailable'); });
return mapLoadPromise;
},
initMap: function () {
if (mapReady) return Promise.resolve(); if (!window.mapboxgl || !stores.length) return Promise.reject(new Error('Mapbox unavailable'));
return new Promise((resolve, reject) => {
mapboxgl.accessToken = accessToken;
map = new mapboxgl.Map({ container: 'map', style: 'mapbox://styles/mapbox/streets-v12', center: stores[0].coordinates, zoom: 8.5, pitch: 0, bearing: 0, attributionControl: false });
map.addControl(new mapboxgl.AttributionControl({ compact: true }));
const timeout = window.setTimeout(() => { if (!mapReady) reject(new Error('Mapbox load timeout')); }, 12000);
map.once('load', () => { window.clearTimeout(timeout); mapReady = true; mapElement.classList.remove('is-loading'); mapElement.classList.add('is-ready'); this.addMarkers(); this.updateOriginMarker(); if (selectedOrigin) this.fitOriginAndStores(); else this.fitStores(); resolve(); });
});
},
createStoreMarkerElement: function (store) {
const markerElement = document.createElement('div'); markerElement.className = 'marker marker--store'; markerElement.dataset.storeHandle = store.handle || store.id; markerElement.setAttribute('role', 'button'); markerElement.setAttribute('tabindex', '0'); markerElement.setAttribute('aria-label', store.name);
const logoHtml = storeLogoUrl ? '<span class="store-marker__logo-wrap"><img src="' + escapeHtml(storeLogoUrl) + '" alt="" class="store-marker__logo"></span>' : '';
markerElement.innerHTML = '<span class="store-marker__pin" aria-hidden="true"><svg viewBox="0 0 64 84" class="store-marker__svg" focusable="false" aria-hidden="true"><path d="M32 2C15.431 2 2 15.431 2 32c0 22.627 30 50 30 50s30-27.373 30-50C62 15.431 48.569 2 32 2Z" fill="currentColor"></path><circle cx="32" cy="30" r="18" fill="#fff"></circle></svg>' + logoHtml + '</span>';
const openStore = () => { this.createPopupMarker(store); this.zoomMarker(store); };
markerElement.addEventListener('click', openStore); markerElement.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openStore(); } });
return markerElement;
},
createOriginMarkerElement: function () {
const markerElement = document.createElement('div'); markerElement.className = 'marker marker--origin'; markerElement.setAttribute('aria-label', 'Startlocatie');
markerElement.innerHTML = '<span class="store-origin-pin" aria-hidden="true"><svg viewBox="0 0 64 84" class="store-origin-pin__svg" focusable="false" aria-hidden="true"><path d="M32 2C15.431 2 2 15.431 2 32c0 22.627 30 50 30 50s30-27.373 30-50C62 15.431 48.569 2 32 2Z" fill="currentColor"></path><circle cx="32" cy="30" r="18" fill="#fff"></circle></svg></span>';
return markerElement;
},
addMarkers: function () {
if (!mapReady) return;
mapElement.querySelectorAll('.marker--store').forEach(element => element.remove());
stores.forEach(store => { if (store.marker) { store.marker.remove(); store.marker = null; } store.marker = new mapboxgl.Marker(this.createStoreMarkerElement(store), { anchor: 'bottom' }).setLngLat(store.coordinates).addTo(map); });
},
updateOriginMarker: function () {
if (originMarker) { originMarker.remove(); originMarker = null; }
if (mapElement) mapElement.querySelectorAll('.store-origin-marker, .marker--origin').forEach(element => element.remove());
if (!mapReady || !selectedOrigin) return;
originMarker = new mapboxgl.Marker(this.createOriginMarkerElement(), { anchor: 'bottom' }).setLngLat(selectedOrigin).addTo(map);
},
fitStores: function () {
if (!mapReady || !stores.length) return; const bounds = new mapboxgl.LngLatBounds(); stores.forEach(store => bounds.extend(store.coordinates));
map.fitBounds(bounds, { padding: { top: 70, right: 50, bottom: 60, left: 50 }, maxZoom: 11.5, duration: 450 });
},
fitOriginAndStores: function () {
if (!mapReady || !selectedOrigin) return; const bounds = new mapboxgl.LngLatBounds(); bounds.extend(selectedOrigin); stores.forEach(store => bounds.extend(store.coordinates));
map.fitBounds(bounds, { padding: { top: 80, right: 60, bottom: 70, left: 60 }, maxZoom: 11.5, duration: 500 });
},
createPopupMarker: function (store) {
if (!mapReady) return; document.querySelectorAll('.mapboxgl-popup').forEach(popup => popup.remove());
const routeUrl = this.getRouteUrl(store); const addressHtml = '<a href="' + escapeHtml(routeUrl) + '" target="_blank" rel="noopener">' + escapeHtml(store.address) + '</a>'; const phoneHtml = store.phone && store.phoneUrl ? '<br><a href="' + escapeHtml(store.phoneUrl) + '">' + escapeHtml(store.phone) + '</a>' : (store.phone ? '<br>' + escapeHtml(store.phone) : '');
new mapboxgl.Popup({ closeOnClick: false }).setLngLat(store.coordinates).setHTML('<h3>' + escapeHtml(store.name) + '</h3><div>' + addressHtml + phoneHtml + '</div>').addTo(map);
},
zoomMarker: function (store) { if (mapReady) map.easeTo({ center: store.coordinates, zoom: 14.5, duration: 450 }); },
getRouteUrl: function (store) {
const destination = store.coordinates[1] + ',' + store.coordinates[0]; let url = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(destination) + '&travelmode=driving';
if (selectedOrigin) { const origin = selectedOrigin[1] + ',' + selectedOrigin[0]; url += '&origin=' + encodeURIComponent(origin); }
return url;
},
getHoursStatusHtml: function (store) {
const todayHours = normalizedTodayHours(store);
if (store.hoursStatus === 'open') return '<div class="store-distance-card__hours-status"><span class="size-3 rounded bg-green" aria-hidden="true"></span><strong>Nu geopend</strong></div><div class="store-distance-card__today">Vandaag: <strong>' + escapeHtml(todayHours) + '</strong></div>';
if (store.hoursStatus === 'closing-soon') { const closeLabel = store.closeTime ? ' · sluit om ' + escapeHtml(store.closeTime) : ''; return '<div class="store-distance-card__hours-status"><span class="size-3 rounded bg-orange" aria-hidden="true"></span><strong>Nu geopend' + closeLabel + '</strong></div><div class="store-distance-card__today">Vandaag: <strong>' + escapeHtml(todayHours) + '</strong></div>'; }
if (store.hoursStatus === 'closed') return '<div class="store-distance-card__hours-status"><span class="size-3 rounded bg-red" aria-hidden="true"></span><strong>Nu gesloten</strong></div><div class="store-distance-card__today">Vandaag: <strong>' + escapeHtml(todayHours) + '</strong></div>';
return '<div class="store-distance-card__today">Bekijk de actuele openingstijden van deze showroom.</div>';
},
renderResults: function () {
const container = document.getElementById('store-distance-results'); if (!container) return;
const hasCalculatedDistance = stores.some(store => Number.isFinite(store.distance));
const orderedStores = stores.slice().sort((a,b) => { if (!hasCalculatedDistance) return 0; const da = Number.isFinite(a.distance) ? a.distance : Number.MAX_SAFE_INTEGER; const db = Number.isFinite(b.distance) ? b.distance : Number.MAX_SAFE_INTEGER; return da - db; });
const fragment = document.createDocumentFragment();
orderedStores.forEach((store,index) => {
const card = document.createElement('article'); card.className = 'store-distance-card' + (hasCalculatedDistance && index === 0 ? ' is-nearest' : '');
const nearestBadge = hasCalculatedDistance && index === 0 ? '<span class="store-distance-card__badge">Dichtstbij</span>' : '';
const pendingText = selectedOriginLabel ? 'Afstand vanaf ' + escapeHtml(selectedOriginLabel) + ' wordt berekend…' : 'Bereken afstand vanaf jouw startlocatie';
const distanceInfo = Number.isFinite(store.distance) && Number.isFinite(store.duration) ? '<div class="store-distance-card__travel"><strong>' + escapeHtml(formatDistance(store.distance)) + '</strong><span>' + escapeHtml(formatDuration(store.duration)) + ' rijden</span></div>' : '<div class="store-distance-card__travel store-distance-card__travel--empty">' + pendingText + '</div>';
const hoursLink = store.hoursUrl ? '<a class="store-distance-card__hours-link" href="' + escapeHtml(store.hoursUrl) + '">Alle openingstijden</a>' : '';
card.innerHTML = '<div class="store-distance-card__top"><button type="button" class="store-distance-card__focus">' + escapeHtml(store.name) + '</button>' + nearestBadge + '</div><div class="store-distance-card__address">' + escapeHtml(store.address) + '</div>' + distanceInfo + '<div class="store-distance-card__hours">' + this.getHoursStatusHtml(store) + '</div><div class="store-distance-card__actions"><a class="store-distance-card__route" href="' + escapeHtml(this.getRouteUrl(store)) + '" target="_blank" rel="noopener">Route bekijken</a>' + hoursLink + '</div>';
const focusButton = card.querySelector('.store-distance-card__focus'); if (focusButton) focusButton.addEventListener('click', () => { this.loadMap().then(() => { this.createPopupMarker(store); this.zoomMarker(store); }); });
fragment.appendChild(card);
});
container.replaceChildren(fragment);
},
setStatus: function (message) { const status = document.getElementById('store-location-status'); if (status) status.textContent = message || ''; }
};
})();
BlsCreateMapStoreLocation.init();
